module.exports = __webpack_public_path__ + "img/Icon__Arrests.b08f03c4.svg";